import { render, staticRenderFns } from "./Editaddress.vue?vue&type=template&id=58289861&scoped=true&"
import script from "./Editaddress.vue?vue&type=script&lang=js&"
export * from "./Editaddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58289861",
  null
  
)

export default component.exports